import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

export class SearchSuggestForm extends FormBase {
    public getProductSearchInputs(root: ParentNode = document): HTMLInputElement[] {
        return this.queryElements(
            root,
            `[data-role="${Roles.PRODUCT_SEARCH_FORM}"] [data-role="${Roles.SEARCH_FORM_INPUT}"]`,
            HTMLInputElement,
        );
    }

    public getBoardSearchInputs(root: ParentNode = document): HTMLInputElement[] {
        return this.queryElements(
            root,
            `[data-role="${Roles.BOARD_SEARCH_FORM}"] [data-role="${Roles.SEARCH_FORM_INPUT}"]`,
            HTMLInputElement,
        );
    }

    public getBrandListSearchInputs(root: ParentNode = document): HTMLInputElement[] {
        return this.queryElements(root, `[data-role="${Roles.BRANDS_SIDEBAR_KEYWORD}"]`, HTMLInputElement);
    }

    public getProductFilterKeywordInputs(root: ParentNode = document): HTMLInputElement[] {
        return this.queryElements(root, `[data-role="${Roles.FILTER_SIDEBAR_KEYWORD_SEARCH}"]`, HTMLInputElement);
    }

    public getBoardSearchForm(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.BOARD_SEARCH_FORM}"]`, HTMLElement);
    }

    public getClosestForm(element: Element | null | undefined): HTMLFormElement | null {
        if (!(element instanceof Element)) return null;
        return this.closest(element, "form", HTMLFormElement);
    }

    public getNamedSearchInput(root: ParentNode): HTMLInputElement | null {
        return this.getInput(root, 'input[name="search"]');
    }

    public getItems(root: ParentNode): HTMLElement[] {
        return this.queryElements(root, `[data-role="${Roles.SEARCH_SUGGEST_ITEM}"]`, HTMLElement);
    }

    public getElementBySelector(selector: string, root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, selector, HTMLElement);
    }

    public getClosestItem(element: Element | null | undefined): HTMLElement | null {
        if (!(element instanceof Element)) return null;
        return this.closest(element, `[data-role="${Roles.SEARCH_SUGGEST_ITEM}"]`, HTMLElement);
    }

    public getItemText(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_SUGGEST_TEXT}"]`, HTMLElement);
    }

    public getSuggestImages(root: ParentNode): HTMLImageElement[] {
        return this.queryElements(root, ".suggest-image", HTMLImageElement);
    }
}

export const searchSuggestForm = new SearchSuggestForm();
